<template>
  <v-dialog
    v-if="applicationModal"
    v-model="modalValue"
    :max-width="applicationModal.isCompanyApplication ? '613' : '581px'"
  >
    <v-card>
      <v-card-title>
        <div class="display-1">LÄRLINGSANMÄLAN</div>
      </v-card-title>

      <v-icon
        class="close"
        @click="close"
      >$sl-close</v-icon>

      <v-card-text class="mt-n7">
        <div v-if="applicationModal && applicationModal.texts">
          <div>
            <div class="overline">Process</div>
            <div class="body-1">{{ applicationModal.texts.process }}</div>
          </div>
          <div>
            <div class="overline">Steg</div>
            <div class="body-1">{{ applicationModal.texts.applicationStep }}</div>
          </div>
          <div>
            <div class="overline">VAD SOM HAR HÄNT</div>
            <div class="body-1">{{ applicationModal.texts.motive }}</div>
          </div>
          <div>
            <div class="overline">VEM SOM AGERAT</div>
            <div class="body-1">
              {{ getName(applicationModal.texts.actor).label }}
            </div>
          </div>
          <div>
            <div class="overline">VAD SOM HÄNDER NÄST</div>
            <div class="body-1">{{ applicationModal.texts.next }}</div>
          </div>
          <div>
            <div class="overline">VEM HAR BOLLEN</div>
            <div class="body-1 mb-n4">
              {{ getName(applicationModal.texts.dependsOn).label }}
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {STATUS_TEXTS} from '@/lib/status-texts.js'
import get from 'lodash/get'

export default {
  name: 'ApplicationInfoModal',

  components: {},

  props: {
    showInfo: {
      type: Boolean,
      default: false
    },
    application: {
      type: Object,
      required: true
    }
  },

  computed: {
    modalValue: {
      get() {
        return this.showInfo
      },

      set(val) {
        this.$emit('close', val)
      }
    },

    applicationModal() {
      if (!this.application || !this.application.state || !this.application.state.state) return
      const type = this.application.isCompanyApplication ? 'company' : 'apprentice'
      const distanceEducation = (this.application.distanceEducation || this.application.education?.type === 'DistanceEducation')
      const numsteps = Object.keys(STATUS_TEXTS[type]).length
      const index = Object.keys(STATUS_TEXTS[type]).indexOf(this.application.state.state) + 1

      const getTexts = () => {
        if ( this.application.transferOldProfession ) {

          if ( !this.application.transferOldProfessionApproved ) {

            if ( !distanceEducation && this.application.state.state === 'closed' ) {
              return STATUS_TEXTS[type]['transferBasicEducationCertificateApproved']
            }

            if ( !this.application.transferApprovedById ) {
              return STATUS_TEXTS[type][this.application.state.state]
            } else {
              return STATUS_TEXTS[type][ distanceEducation ? 'transferDistanceEducationIssued' : 'transferBasicEducationCertificateIssued' ]
            }

          } else {
            return STATUS_TEXTS[type][ distanceEducation ? 'transferDistanceEducationApproved' : 'transferBasicEducationCertificateApproved' ]
          }
        } else {
          if ( !distanceEducation && this.application.state.state === 'closed' ) {
            return STATUS_TEXTS[type].closedDistanceEducation
          }
          return STATUS_TEXTS[type][this.application.state.state]
        }
      }

      const apprentice = `${this.application.firstName} ${this.application.lastName}`
      this.application.apprentice = apprentice
      this.application.index = index
      this.application.numsteps = numsteps
      this.application.texts = getTexts()
      return this.application
    },
  },

  methods: {
    close() {
      this.modalValue = false
    },

    getName(type) {
      let label

      const region = get(this.application, 'workplace.region.name', '')
      const company = get(this.application, 'company.name', '')
      const orderedBy = this.application.orderedBy ?
        `${this.application.orderedBy.firstName} ${this.application.orderedBy.lastName}` :
        'Regionar 1'
      const approvedBy = this.application.approvedBy ?
        `${this.application.approvedBy.firstName} ${this.application.approvedBy.lastName}` :
        'Regionar 2'
      switch (type) {
        case 'Lärlingen':
          const haveName = this.application.firstName && this.application.lastName
          label = haveName ? `${this.application.firstName} ${this.application.lastName}` : 'Lärlingen'
          break
        case 'Företaget':
          label = company
          break
        case 'Regionär med behörighet till BYN {{region}}':
          label = `Regionär med behörighet till BYN ${region}`
          break
        case 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}': {
          label = `Annan regionär än ${orderedBy} med behörighet till BYN ${region}`
          break
        }
        case '{{orderedBy}} (BYN {{region}})': {
          label = `${orderedBy} (BYN ${region})`
          break
        }
        case '{{approvedBy}} (BYN {{region}})': {
          label = `${approvedBy} (BYN ${region})`
          break
        }

        default:
          label = type
      }
      return {
        label: label || type
      }
    }
  }
}
</script>

<style>
</style>